import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { Injectable } from '@angular/core'

export type ZipEntry = { name: string; blob: Blob | ArrayBuffer | Uint8Array }

@Injectable({
	providedIn: 'root'
})
export class ZipService {
	constructor() {}

	async buildZip(entries: ZipEntry[], level: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 = 6): Promise<Blob> {
		const zip = new JSZip()

		for (const it of entries) {
			zip.file(it.name, it.blob, { binary: true })
		}

		return zip.generateAsync({
			type: 'blob',
			compression: 'DEFLATE',
			compressionOptions: { level }
		})
	}

	async downloadZip(entries: ZipEntry[], filename = 'arquivos.zip', level: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 = 6) {
		const zipBlob = await this.buildZip(entries, level)
		saveAs(zipBlob, filename)
	}
}
